import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';

import RootRoutes from 'routes';

import { ToastContainer } from 'react-toastify';

import ErrorBoundary from 'components/core/ErrorBoundary';

import { BrowserRouter } from 'react-router-dom';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import SiteBlocker from 'components/core/SiteBlocker';
import AuthModalProvider from 'state/contexts/authModalContext';
import HeaderContextProvider from 'state/contexts/headerContext';
import { $session } from 'state/stores';
import { queryClient } from 'utils';

function App() {
  const isAuthenticated = $session.selectors.useIsAuthenticatedBySiteBlocker();
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <QueryClientProvider client={queryClient}>
          <SiteBlocker />
          {isAuthenticated ? (
            <BrowserRouter>
              <HeaderContextProvider>
                <AuthModalProvider>
                  <RootRoutes />
                </AuthModalProvider>
              </HeaderContextProvider>
            </BrowserRouter>
          ) : null}
          <ToastContainer
            position="bottom-center"
            style={{ zIndex: 9999 }}
            toastStyle={{ zIndex: 9999 }}
          />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
